import type { UFile } from '@w/utils'
import type { FileHandler, FileUploadItem } from './types'

export interface UploadCallbacks {
  prepared?: (items: FileUploadItem[]) => void
  completed: (srcs: string[], items: FileUploadItem[]) => void
}

/** Every consumer shares the same ownership checks at both asynchronous boundaries. */
export async function uploadForOwner(handler: FileHandler, files: UFile[], signal: AbortSignal, callbacks: UploadCallbacks) {
  const { items, done } = await handler.upload(files)
  let cleaned = false
  const cleanup = () => {
    if (cleaned) return
    cleaned = true
    for (const item of items) item.cleanup?.()
  }
  signal.addEventListener('abort', cleanup, { once: true })
  try {
    if (signal.aborted) cleanup()
    else callbacks.prepared?.(items)
    const { srcs } = await done
    if (signal.aborted) return
    callbacks.completed(srcs, items)
  } finally {
    signal.removeEventListener('abort', cleanup)
    cleanup()
  }
}
